import { type I18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import store from 'shared/store'
import RxByPrincipleModalContainer from 'views/containers/browser/RxByPrincipleModalContainer'

const RxByPrincipleModalContainerWithRenderer = ({
  container,
  i18n,
  offerIdsWithAlreadySelectedReasons = [],
}: {
  container: Element
  i18n: I18n
  offerIdsWithAlreadySelectedReasons?: string[]
}) => {
  render(
    // @ts-expect-error -- need to check types
    <Provider store={store}>
      <I18nProvider i18n={i18n}>
        <RxByPrincipleModalContainer
          offerIdsWithAlreadySelectedReasons={
            offerIdsWithAlreadySelectedReasons
          }
        />
      </I18nProvider>
    </Provider>,
    container
  )
}

export default RxByPrincipleModalContainerWithRenderer
